import React, { useContext } from 'react';
import { View } from '@shared/components/View';
import { ColorThemeContext, grid } from '@shared/styles';
import { useLayoutConfig } from './contexts/layoutConfig';
import { CardRenderContext } from './contexts/render';

interface Props {
  singleLine?: boolean;
}

export function MBRedactedCardLines({ singleLine }: Props) {
  const colors = useContext(ColorThemeContext);
  const {
    staticBlock: { paddingLeft },
  } = useLayoutConfig();
  const renderContext = useContext(CardRenderContext);
  const lineHeight = renderContext === 'calendar' ? grid(1.25) : grid(1.5);
  const spacing = renderContext === 'calendar' ? 0.5 : 1;
  return (
    <View paddingLeft={paddingLeft} paddingRight={1} flex>
      <View
        style={{
          backgroundColor: colors.foregroundInactive,
          height: lineHeight,
          borderRadius: lineHeight / 2,
          width: '100%',
          maxWidth: grid(40),
        }}
        marginVertical={spacing}
      />
      {!singleLine && (
        <View
          style={{
            backgroundColor: colors.foregroundInactive,
            height: lineHeight,
            borderRadius: lineHeight / 2,
            width: '75%',
            maxWidth: grid(30),
          }}
          marginVertical={spacing}
        />
      )}
    </View>
  );
}
